import axios from '@/axios/api.request'

export const save = (form) => axios.request({
    url: '/collect/money/save',
    data: form,
    method: 'post'
  })

export const end = (form) => axios.request({
    url: '/collect/money/end',
    data: form,
    method: 'post'
  })